import { faUser } from "@fortawesome/free-solid-svg-icons";
import createField from "../../../utils/factory/createField";

export const filterFields = [
  {
    section: "Filtros para o relatório",
    fields: [
      createField({
        id: "filter.customer_id",
        label: "Cliente",
        placeholder: "Selecione o cliente contratante",
        type: "select",
        icon: faUser,
        fullWidth: true,
        isClearable: true,
      }),
      createField({
        id: "filter.recipient_customers_ids",
        label: "Sub-clientes",
        type: "select",
        placeholder: "Selecione o sub-cliente",
        isMulti: true,
        fullWidth: true,
      }),
      createField({
        id: "filter.address_ids",
        label: "Destinos",
        placeholder: "Selecione o destino",
        type: "select",
        isMulti: true,
        fullWidth: true,
      }),
      createField({
        id: "filter.with_reserved",
        label: "Incluir equipamentos reservados?",
        placeholder: "Selecione a opção desejada",
        type: "select",
        isMulti: false,
      }),
      createField({
        id: "filter.with_maintenances",
        label: "Incluir equipamentos em manutenção?",
        placeholder: "Selecione a opção desejada",
        type: "select",
        isMulti: false,
      }),
      createField({
        id: "filter.with_others",
        label: "Mostrar outras situações?",
        placeholder: "Selecione a opção desejada",
        type: "select",
        isMulti: false,
        fullWidth: true,
      }),
    ],
  },
];
